import React, { useState} from 'react';
import { motion} from "framer-motion"
import ReactToolTip from "react-tooltip"
import { images } from '../../constants';
import {AppWrap} from "../../wrapper"
import './Skills.scss'; 
const experiences = [
     {
        year: "2022",
        works:{
            name: "Backend Developer and Project Manager", company: "Qualibyte", desc: "I am working as an backend developer at qualibyte, in charge of the whole backend endpoint and also managing their server, guiding the frontend devs with the binding and helping the UX guy with the over all bird eye view of the app... making sure each and every section is moving fluently."
        }
    },
    {
        year: "2020",
        works:{
            name: "Content Creator", company: "BiFound", desc: "I was in charge of creating content and posting for their Instagram page."
        }
    },
    {
        year: "2018",
        works:{
            name: "Software Engineer Intern", company: "BiFound", desc: "Search Engine with, HTML | CSS | JQuery | PHP | SQL "
        }
    },
    {
        year: '2017',
        works:{
            name: 'Software Engineer', company: "Kontec Digital System", desc: "Hospital Management sys with, Visual basic | Access Database | HTML|CSS| Javascript |PHP"
        },
    },
    {
        year: "2015",
        works:{
            name: "Software manager", company: "Zakrina Design LTD", desc: "I was contracted by a team overseas to assist with software updates, performs around the clock server maintenance and overall system management."
        }
    },
    
    
    
   
]

/*SKILLS
HTML | CSS 
JavaScript | Node JS | React JS
PHP | MYSQL | Typescript | 
MongoDB | Express JS | 
Graphql | Nexus | Prisma
Sequelize
*/

const skillsQuery = [
    {name: "HTML", icon: images.html},
    {name: "CSS", icon: images.css},
    {name: "JavaScript", icon: images.javascript},
    {name: "Sass", icon: images.sass},
    {name: "Node", icon: images.node},
    {name: "React", icon: images.react},
    {name: "Redux", icon: images.redux},
    {name: "TypeScript", icon: images.typescript},
    {name: "Git", icon: images.git},
    {name: "API", icon: images.api},
    {name: "GraphQl", icon: images.graphql},
    {name: "PHP", icon: images.php},
    {name: "ANGULAR", icon: images.angular},
    
]

const Skills = () => {

    const [skills] = useState(skillsQuery)
    const [experience] = useState(experiences)


    return(
        <>
        <h2 className='head-text'> Skills & Experience</h2>

        <div className='app__skills-container'>
            <motion.div className='app__skills-list'>
            {skills.map((skill) => (
                <motion.div
                whileInView={{opacity: [0, 1]}}
                transition = {{duration: 0.5}}
                className = 'app__skills-item app__flex'
                key={skill.name}
                >

                  <div className='app__flex'>
                    <img src={skill.icon} alt={skill.name}/>
                  </div>
                  <p className='p-text'>{skill.name}</p>
                </motion.div>
             ))}
            </motion.div>
            <motion.div className='app__skills-exp'>
                {experience.map((experience)=> (
                        <motion.div
                        className='app__skills-exp-item'
                        key={experience.year}
                        >
                            <div className='app__skills-exp-year'>
                            <p className='bold-text'>{experience.year}</p>
                            </div>
                            <motion.div className='app__skills-exp-works'>
                            {/* {experience.works.map((work) => ( */}
                            <>
                            <motion.div
                            whileInView = {{opacity: [0,1]}}
                            transition = {{duration: 0.5}}
                            className = "app__skills-exp-work"
                            data-tip
                            data-for = {experience.works.name}
                            key={experience.works.name}
                            >
                            <h4 className='bold-text'>{experience.works.name}</h4>
                            <p className='p-text'>{experience.works.company}</p>
                        </motion.div>
                            <ReactToolTip
                            id={experience.works.name}
                            effect ='solid'
                            arrowColor='#fff'
                            className='skills-tooltip'
                            >
                            {experience.works.desc}
                            </ReactToolTip>
                            </>
                            {/* ))} */}
                        </motion.div>
                    </motion.div>
                    ))}
           </motion.div>
        </div>
        </>
    )
}

export default AppWrap(Skills, 'skills');